<!-- Copyright © 2024 Insurance Services Office, Inc. All rights reserved -->

@if ((this.loader.loading$ | async)) {
  <div class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
  </div>
}